module.exports = [{"type":"hash","text":"Access"},{"type":"normal","text":"Market Websocket access URL: wss://open-api-ws.bingx.com/market"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/introduce/02_connect.json
// module id = hDC3
// module chunks = 3